// Robust fallback data for CARPA ApS - Cleaned and updated to match the new specifications
export const FALLBACK_PAGES = {
  index: {
    title: "Fra projekt til sikker drift - CARPA ApS",
    meta_description: "CARPA ApS hjælper PtX-, energi- og procesindustrien med commissioning, operational readiness, technical leadership og handover. Vi skaber struktur i den kritiske fase.",
    content: `
      <h1>Fra projekt til sikker drift</h1>
      <p>CARPA hjælper PtX-, energi- og procesindustrien med commissioning, operational readiness, technical leadership og handover. Vi skaber struktur i den kritiske fase, hvor komplekse anlæg skal testes, overleveres og bringes sikkert i drift.</p>
    `,
    gallery_slug: "industri-site-work"
  },
  ydelser: {
    title: "Ydelser - CARPA ApS",
    meta_description: "Professionel rådgivning og praktisk eksekvering inden for Commissioning Management, Operational Readiness, Technical Leadership, Handover & Start-up Support og Strategic Maintenance.",
    content: `
      <h2>Ydelser</h2>
      <p>CARPA leverer praktisk, teknisk og driftssikker rådgivning fra projekt til sikker drift. Vi har fokus på praktisk eksekvering og tæt samarbejde.</p>
    `,
    gallery_slug: "commissioning"
  },
  "om-carpa": {
    title: "Om CARPA - CARPA ApS",
    meta_description: "Læs om CARPAs tekniske erfaring, hands-on tilgang og fokus på sikker drift og gennemførelse i komplekse industrielle projekter.",
    content: `
      <h2>Om CARPA</h2>
      <p>CARPA hjælper industri-, energi- og procesvirksomheder med at skabe struktur, fremdrift og teknisk kontrol i overgangen fra projekt til drift.</p>
      <p>Vi kombinerer praktisk site-erfaring, commissioning-ledelse og teknisk forståelse med en hands-on tilgang til test, dokumentation, handover, drift og vedligehold.</p>
    `,
    gallery_slug: "operational-readiness"
  },
  kontakt: {
    title: "Kontakt - CARPA ApS",
    meta_description: "Kontakt CARPA ApS for en uforpligtende snak om jeres næste projekt. Vi er klar til at hjælpe jer sikkert i drift.",
    content: `
      <h2>Kontakt os</h2>
      <p>Har du spørgsmål til vores ydelser, eller ønsker du en uforpligtende snak om, hvordan vi kan hjælpe dit projekt sikkert i drift? Kontakt os i dag.</p>
    `
  },
  privatlivspolitik: {
    title: "Privatlivspolitik - CARPA ApS",
    meta_description: "Cookie- og privatlivspolitik hos CARPA ApS",
    content: `
      <h1>Privatlivspolitik</h1>
      <h3>Cookie- og privatlivspolitik hos CARPA ApS</h3>
      <p><strong>Introduktion</strong></p>
      <p>Når du besøger vores website indsamles der oplysninger om dig, som bruges til at tilpasse og forbedre vores indhold. Hvis du ikke ønsker, at der indsamles oplysninger, bør du slette dine cookies og undlade videre brug af websitet.</p>
      <p><strong>Cookies</strong></p>
      <p>Websitet anvender “cookies”, der er en tekstfil, som gemmes på din computer, mobil el. tilsvarende med det formål at genkende den, huske indstillinger og udføre statistik.</p>
      <h4>Personoplysninger</h4>
      <p><strong>Generelt</strong></p>
      <p>Personoplysninger er alle slags informationer, der i et eller andet omfang kan henføres til dig. Vi behandler dine personoplysninger sikkert og fortroligt i overensstemmelse med gældende lovgivning, herunder persondataforordningen og databeskyttelsesloven.</p>
      <p><strong>Udgiver</strong></p>
      <p>Websitet ejes og publiceres af: CARPA ApS, Grævlinghøjen 12, 8800 Viborg, Telefon: +45 53 63 62 23, Email: llk@carpa.dk</p>
    `
  }
};

export const FALLBACK_GALLERIES = {
  commissioning: {
    title: "Commissioning",
    description: "Billeder fra teknisk commissioning, testforløb og idriftsættelse af komplekse procesanlæg.",
    images: [
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/08508acd-3c99-43a6-ad1d-6683a0f16c26.jpg",
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/5bdb1c31-d752-4ddb-94fa-7d80940b2cde.webp",
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/37c78cb0-e752-428e-ab80-b86936a16228.jpg"
    ]
  },
  "operational-readiness": {
    title: "Operational Readiness",
    description: "Forberedelse af drift, overlevering og sikring af operationel parathed.",
    images: [
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/594540e3-6717-499c-be64-92e37498def2.jpg",
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/afe43705-5832-4975-9507-5d77c6c4492e.jpg",
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/ad3a5af6-09f1-4924-9433-0a99ce0d0394.webp"
    ]
  },
  "industri-site-work": {
    title: "Industri & Site Work",
    description: "Hands-on arbejde på anlæg, opretning, vibrationsmåling og fejlfinding i marken.",
    images: [
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/d36f4a04-7856-4167-ba47-71741bdc65b9.jpg",
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/afe43705-5832-4975-9507-5d77c6c4492e.jpg",
      "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/5bdb1c31-d752-4ddb-94fa-7d80940b2cde.webp"
    ]
  }
};

export const LOGOS = [
  { name: "Alfa Laval", url: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/af311c82-f6d1-4936-952a-8adfff6df613.svg" },
  { name: "Silkeborg Forsyning", url: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/9c5ec6e9-8466-486b-a3c1-b850f9b50a49.svg" },
  { name: "MEC", url: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/c18d574d-d103-4da8-9e52-4d603b521300.svg" },
  { name: "WMO", url: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/a9e29aa7-1702-4c9e-bdf5-df11bd135184.png" },
  { name: "B&W", url: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/b665f9a7-0307-459d-a40d-41a9dd17f225.png" },
  { name: "Ineos", url: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/f6b36d86-0f36-44bf-8a36-291e296a8893.webp" }
];

// Generiske kurser til kursussiden
export const FALLBACK_COURSES = [
  {
    id: "strategisk-vedligehold",
    title: "Strategisk vedligehold",
    date: "Efter aftale / Løbende",
    target_audience: "Driftsledere, vedligeholdelsesansvarlige og maskinmestre",
    duration: "2 dage",
    description: "Dette kursus fokuserer på opbygning af en effektiv vedligeholdsstruktur, der reducerer nedetid og optimerer anlæggets levetid. Lær at omsætte strategiske mål til praktiske vedligeholdelsesrutiner og CMMS-opsætning."
  },
  {
    id: "commissioning",
    title: "Commissioning",
    date: "Efter aftale / Løbende",
    target_audience: "Projektledere, maskinmestre, driftsledere og tekniske rådgivere",
    duration: "3 dage",
    description: "Lær at planlægge, styre og eksekvere commissioning-processer på komplekse tekniske anlæg. Kurset giver dig praktiske værktøjer til test, interface-styring, punch-håndtering og sikker overdragelse fra projekt til stabil drift."
  },
  {
    id: "operational-readiness",
    title: "Operational Readiness",
    date: "Efter aftale / Løbende",
    target_audience: "Driftsorganisationer, projektteams og vedligeholdelsesansvarlige",
    duration: "2 dage",
    description: "Få styr på alle aspekter af operationel parathed. Vi gennemgår, hvordan du forbereder driftsteamet, opbygger procedurer, sikrer reservedelsstrategi og etablerer et stærkt CMMS-grundlag, før anlægget overtages."
  },
  {
    id: "risk-safety",
    title: "Risk & Safety",
    date: "Efter aftale / Løbende",
    target_audience: "Sikkerhedskoordinatorer, procesingeniører og tekniske ledere",
    duration: "1 dag",
    description: "En generisk introduktion til risikovurdering og funktionel sikkerhed på industrielle anlæg. Få indblik i HAZOP/HAZID-metoder, risikostyring og hvordan sikkerhed tænkes ind fra projektfase til daglig drift."
  }
];

// Troværdige referencer til referencesiden (herunder THOR/RWE)
export const FALLBACK_REFERENCES = [
  {
    id: "rwe-thor",
    title: "RWE / THOR Havvindmøllepark",
    client: "RWE / THOR",
    project_type: "Commissioning & Operational Readiness Support",
    image: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/afe43705-5832-4975-9507-5d77c6c4492e.jpg",
    description: "Support til planlægning og strukturering af commissioning-aktiviteter samt operational readiness forberedelser i forbindelse med etableringen af Danmarks hidtil største havvindmøllepark, Thor. CARPA bidrager med teknisk styring og sikring af interfaces mellem projekt og drift."
  },
  {
    id: "ptx-pilot",
    title: "Power-to-X (PtX) Pilotanlæg",
    client: "Førende dansk energiselskab",
    project_type: "Technical Leadership & Handover",
    image: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/d36f4a04-7856-4167-ba47-71741bdc65b9.jpg",
    description: "Teknisk ledelse og idriftsættelsessupport på et af Danmarks første PtX-pilotprojekter. CARPA sikrede den kritiske overgang fra mekanisk færdiggørelse til verificeret funktion, herunder koordinering af leverandører og udarbejdelse af driftsprocedurer."
  },
  {
    id: "modernisering-proces",
    title: "Modernisering af Procesanlæg",
    client: "Industriel procesvirksomhed",
    project_type: "Strategic Maintenance & Commissioning",
    image: "https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/594540e3-6717-499c-be64-92e37498def2.jpg",
    description: "Etablering af nyt vedligeholdelsesgrundlag (CMMS) og commissioning-ledelse under en omfattende opgradering af et komplekst procesanlæg. CARPA sikrede, at anlægget blev overdraget til drift med fuldt opdateret dokumentation og en klar reservedelsstrategi."
  }
];
